<script setup lang="ts">
import { cva, VariantProps } from 'class-variance-authority'
import { type AccordionRootProps } from 'radix-vue'

import { ProductCardWithPurchaseOptions } from '@toni/commerce-api-types'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@toni/brand-ui'

import AlternativePurchaseOptions from '../AlternativePurchaseOptions.vue'
import { useClient } from '../../utils/is-client'
import { BUTTON_TYPE } from '../../utils/types'

const alternativePurchaseOptionsAccordionVariants = cva(
  '',
  {
    variants: {
      variant: {
        desktop: 'basis-1/4',
        mobile: 'basis-1/2'
      }
    }
  }
)

type AlternativePurchaseOptionsAccordionProps = VariantProps<typeof alternativePurchaseOptionsAccordionVariants>

defineProps<{
  productCards: ProductCardWithPurchaseOptions[],
  variant?: AlternativePurchaseOptionsAccordionProps['variant']
  accordionOpenId: AccordionRootProps['modelValue']
}>()

const { isClient } = useClient()

const emit = defineEmits(['update-accordion-open-id'])
</script>

<template>
  <Accordion v-if="isClient"
             type="single"
             class="clear-both w-full"
             :model-value="accordionOpenId"
             @update:model-value="emit('update-accordion-open-id', $event)">
    <AccordionItem value="desc"
                   class="w-full">
      <AccordionTrigger>
        <span class="text-heading-xs">{{ $t('commerce.purchaseOptions') }}</span>
      </AccordionTrigger>
      <AccordionContent>
        <div class="h-full flex flex-row gap-2 w-full">
          <div v-for="product in productCards"
               :key="`${product.bauerProductCard.bauerProductCardId}-alternative-purchase-options`"
               :class="alternativePurchaseOptionsAccordionVariants({ variant })">
            <AlternativePurchaseOptions v-if="productCards.length"
                                        :alternative-purchase-options="product.purchaseOptions.slice(1)"
                                        :is-comparison="true"
                                        :type="BUTTON_TYPE.icon" />
            <div v-else />
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>
